import ReactionsView from './ReactionsV2.view.vue'
import ReactionsController from './ReactionsV2.controller.js'

export default ReactionsController(ReactionsView)
